import type { QuoteId } from "@@/shared/quotes/quote-id";
import type { Opaque } from "type-fest";

type QuoteEventSignature = Opaque<string, "OrderEventSignature">;
const quoteSignatureFactory = (
    quoteId: QuoteId,
    type: string,
    identifiers?: string[],
): QuoteEventSignature => {
    //What should one hash with??
    const signatureKey =
        quoteId +
        "|" +
        type +
        "|" +
        (identifiers !== undefined ? identifiers.join("|") : "");

    return signatureKey as QuoteEventSignature;
};

export { quoteSignatureFactory };
export type { QuoteEventSignature };
